/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsvat201Inputs */

const en_ticketsvat201 = /** @type {(inputs: Ticketsvat201Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20%`)
};

const de_ticketsvat201 = /** @type {(inputs: Ticketsvat201Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20 %`)
};

/**
* | output |
* | --- |
* | "20%" |
*
* @param {Ticketsvat201Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsvat201 = /** @type {((inputs?: Ticketsvat201Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsvat201Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsvat201(inputs)
	return de_ticketsvat201(inputs)
});
export { ticketsvat201 as "ticketsVat20" }